import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BadInputError, Guard, Result, ValueObject } from '@digibricks/domains';
export var ShuffledHeadingIndex = /*#__PURE__*/function (_ValueObject) {
  _inherits(ShuffledHeadingIndex, _ValueObject);

  var _super = _createSuper(ShuffledHeadingIndex);

  function ShuffledHeadingIndex() {
    _classCallCheck(this, ShuffledHeadingIndex);

    return _super.apply(this, arguments);
  }

  _createClass(ShuffledHeadingIndex, [{
    key: "index",
    get: function get() {
      return this.props.index;
    }
  }, {
    key: "headingId",
    get: function get() {
      return this.props.headingId;
    }
  }], [{
    key: "create",
    value: function create(props) {
      var guardResult = Guard.againstNullOrUndefinedBulk([{
        argument: props.index,
        argumentName: 'Heading Index'
      }, {
        argument: props.headingId,
        argumentName: 'Heading Id'
      }]);

      if (!guardResult.succeeded) {
        return new BadInputError(guardResult.message);
      }

      return Result.ok(new ShuffledHeadingIndex(props));
    }
  }]);

  return ShuffledHeadingIndex;
}(ValueObject);